import { formatCents } from "@/lib/utils";
import type { ColumnKind } from "../types";

/** Render a report cell value for its column kind. Money arrives as integer
 * cents; dates as ISO strings (or null). */
export function formatCell(value: unknown, kind: ColumnKind = "text"): string {
  if (value === null || value === undefined || value === "") return "—";
  if (kind === "money") return formatCents(Number(value));
  if (kind === "int") return String(value);
  if (kind === "date") {
    const d = new Date(String(value));
    return Number.isNaN(d.getTime())
      ? String(value)
      : d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  }
  return String(value);
}
